import { GGCoinClient } from "@developerz.ai/ggcoin-sdk";

/**
 * Build one client per browser session. The base URL comes from
 * `VITE_API_BASE_URL` and falls back to the dev-proxy path `/api`. Tests
 * construct `GGCoinClient` directly with a stub fetch.
 */
export function buildClient(jwt: string | null = null): GGCoinClient {
  const baseUrl = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "/api";
  return new GGCoinClient({ baseUrl, jwt: jwt ?? undefined });
}
